import {request} from "../base/HTTP";
import HttpMethod from "../constants/HttpMethod";

export async function resetPasswordRequest(data) {
    return await request('/api/user/reset-password-request', data, HttpMethod.POST);
}

export async function resetPassword(data) {
    return await request('/api/user/reset-password', data, HttpMethod.POST);
}